import ConTeLogo from "../../assets/logos/conte.logo.svg?react";
import SearchLoanImage from "../../assets/images/search-loan.svg?react";

const Loader = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center gap-10">
      <div className="animate-bounce flex gap-3">
        <ConTeLogo className="w-48" />
        <SearchLoanImage className="w-20" />
      </div>
      <div className="flex flex-col gap-3 text-conte-blue text-center">
        <strong className="text-lg">Stiamo recuperando la pratica...</strong>
        <p>
          ci vorranno pochi attimi e potrai riprendere <br />
          la tua richiesta di prestito personale
        </p>
      </div>
    </div>
  );
};

export default Loader;
